import React from 'react';
import { observer } from 'mobx-react-lite';
import {
    ConfigContainer,
    ConfigRow,
    ConfigLabel,
    ConfigValueCell,
    CurrencyPrefix,
    SubmitButtonWrapper,
} from './ConfigForm.style';
import { CurrencyType, moneySymbol } from 'src_common/common/amount/website-money/currency';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { InputField } from 'src/components/LicenseConfig/shared/InputField/InputField';
import { SectionHeader } from 'src/components/LicenseConfig/shared/SectionHeader/SectionHeader';

interface ConfigFormPropsType {
    title: string;
    tooltip?: string;
    currency: CurrencyType | null;
    fields: Array<{
        key: string;
        label: string;
        formInputState: FormInputState<string, unknown>;
        originalValue: string;
    }>;
    isSaving: boolean;
    onSubmit: () => Promise<void>;
}

export const ConfigForm = observer(
    ({ title, tooltip, currency, fields, isSaving, onSubmit }: ConfigFormPropsType): JSX.Element => {
        const currencySymbol = currency === null ? '' : moneySymbol(currency);
        const hasErrors = fields.some((field) => field.formInputState.result.value.type === 'error');

        const handleSubmit = async (e: React.FormEvent): Promise<void> => {
            e.preventDefault();
            await onSubmit();
        };

        return (
            <form onSubmit={handleSubmit}>
                <SectionHeader
                    title={title}
                    tooltip={tooltip}
                />
                <ConfigContainer>
                    {fields.map((field) => (
                        <ConfigRow key={field.key}>
                            <ConfigLabel>{field.label}</ConfigLabel>
                            <ConfigValueCell>
                                <CurrencyPrefix>{currencySymbol}</CurrencyPrefix>
                                <InputField
                                    formInputState={field.formInputState}
                                    disabled={isSaving}
                                    originalValue={field.originalValue}
                                />
                            </ConfigValueCell>
                        </ConfigRow>
                    ))}
                </ConfigContainer>
                <SubmitButtonWrapper>
                    <Button
                        version='primary'
                        size='regular'
                        isDisabled={isSaving || hasErrors}
                        onClick={handleSubmit}
                    >
                        {isSaving ? 'Saving...' : 'Submit Changes'}
                    </Button>
                </SubmitButtonWrapper>
            </form>
        );
    }
);
